<template>

<core-panel>

	<template v-slot:head>

		<h1>Game Specialists</h1>

		<p>Those who have played the same game the most.</p>

	</template>

	<template v-slot:body>

		<app-user type="player" :item="item" v-for="(item, index) in specialised" :override-name="$store.getters['data/games/associated'][item.game].name" :key="index" count-text="play" />

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'specialised',
			specialised: []
		}

	},

	methods: {

		response: function(json) {

			this.specialised = json.specialised.specialised

		}

	}

}

</script>